<template>
  <div>
    <h1>Retirar verificación provisional</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Responsable">
                <a-input
                disabled
                v-model="$v.updateVerification.updatedBy.$model"
                />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Concesión">
                <a-input
                  disabled
                  v-model="$v.updateVerification.numConcesion.$model"
                />
                <small class="text-danger" v-if="!$v.updateVerification.numConcesion.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="RFC">
                <a-input
                  disabled
                  v-model="$v.updateVerification.rfc.$model"
                />
                 <small class="text-danger" v-if="!$v.updateVerification.rfc.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Periodo">
                <a-input
                disabled
                v-model="$v.updateVerification.period.$model"
                />
                 <small class="text-danger" v-if="!$v.updateVerification.period.required">Campo requerido. No debe estar vacío.</small>
                 <small class="text-danger" v-if="!$v.updateVerification.period.period">Solo se permite fecha por números.</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredConcesion($v.updateVerification.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { required, helpers } from 'vuelidate/lib/validators'
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
const period = helpers.regex('period', /^([12]\d{3}-([1-9]|1[0-2]))$/)
export default {
  data() {
    return {
      disabledButton: false,
      form: this.$form.createForm(this),
      updateVerification: {
        updatedBy: this.$store.state.user.email,
        rfc: this.$route.params.concesionario.rfc,
        numConcesion: this.$route.params.concesionNumber,
        period: '',
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredConcesiones: {},
      // getAllConceciones: []
    }
  },
  apollo: {
    getVerification: {
      query: gql`query getVerification($rfc: String, $numConcesion: String){
          getVerification(rfc: $rfc numConcesion: $numConcesion){
          periodo
          }
        }`,
      context: headers(),
      variables() {
        return {
          rfc: this.updateVerification.rfc,
          numConcesion: this.updateVerification.numConcesion,
        }
      },
      error (erro) {
        console.log('Ocurrió un error')
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data.getVerification.periodo, 'error')
        this.totalRows = data.getVerification.length
        this.updateVerification.period = data.getVerification.periodo
      },
    },
  },
  methods: {
    async handleSubmit() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      await this.$apollo.mutate({
        mutation: gql`mutation updateVerification($updatedBy: String, $rfc: String, $numConcesion: String, $period: String){
         updateVerification(updVerificationInput: {
          updatedBy: $updatedBy
          rfc: $rfc
          numConcesion: $numConcesion
          period: $period
        }){
          success
        }
        }`,
        context: headers(),
        variables: {
          updatedBy: this.updateVerification.updatedBy,
          rfc: this.updateVerification.rfc,
          numConcesion: this.updateVerification.numConcesion,
          period: this.updateVerification.period,
        },
      })
        .then(res => {
          console.log(this.updateVerification, 'creado')
          this.$router.push('/concessions/getConcessions')
        })
        .catch(error => {
          console.log(this.updateVerification, 'No salio')
          console.log(error)
          this.disabledButton = false
          this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
          this.mensaje.color = 'warning'
          this.showAlert()
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredConcesion(concesionNumber) {
      if (this.updateVerification[concesionNumber]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
  },
  validations: {
    updateVerification: {
      updatedBy: { required },
      rfc: { required },
      numConcesion: { required },
      period: { required, period },
    },
  },
}
</script>

<style>

</style>
